import { render, staticRenderFns } from "./ShippingPopover.vue?vue&type=template&id=6af915dc&scoped=true"
import script from "./ShippingPopover.vue?vue&type=script&lang=js"
export * from "./ShippingPopover.vue?vue&type=script&lang=js"
import style0 from "./ShippingPopover.vue?vue&type=style&index=0&id=6af915dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af915dc",
  null
  
)

export default component.exports